<template>
  <div>
  </div>
</template>

/*
This componenent is intended to be iframed and is used to connect / make api calls.
The methods it supports for comparison are... 
1: getCompareStatus
2: toggleCompare
*/

<script>
  import Constants from '../../constants.js'

  import axios from 'axios'

  import { inject, toRaw } from 'vue'

  // import AuthUtil from '../../authUtil'

  export default {
    name: 'PluginConnect',
    setup () {
      const firebaseApp = inject('firebase')
      return {
        firebaseApp
      }
    },
    data () {
      return {
        authenticated: false,
        currentUser: null,
        // serviceId: null,
        method: null,
        embedderId: null,
        persistent: false,
        context: null,
        pikleUID: null,
        currentUserUID: null,
        appMode: null,
        taxonModesMap: null,
        hasTestingAccess: false,
        modePriorityMap: {
          disabled: 2,
          testing: 1,
          enabled: 0
        },
        preInitMessages: [],
        initialized: false,
        authUtility: null,
        jwtToken: null,
        jwtTokenCreatedAt: null,
        jwtMaxAge: 3600000 // 1hr in ms
      }
    },
    mounted: function () {
      this.initialize()
    },
    methods:  {
      initialize: async function () {
        this.authenticated = false;
        // const auth = AuthUtil.auth;
        // if (auth.currentUser) {
        //   this.authenticated = true
        //   this.pikleUID = auth.currentUser.uid
        // }

        // Require a method and orgin domain and embedderId so we can run a method and send a response
        // this.serviceId = 'comparison' // this.$route.query['service'] || null;
        this.method = this.$route.query['method'] || null;
        this.embedderId = this.$route.query['embedderId'] || null;
        const mode = this.$route.query['mode'] || null;
        this.persistent = mode ? mode === 'persistent' : false;
        const uid = this.$route.query['uid'] || null;
        // if (!this.authenticated) {
          this.pikleUID = uid
        // }

        // Authenticated and has expected params
        if (this.embedderId && this.buildContext()) {
          if (this.pikleUID) {

            if (this.persistent && this.context.origin) {
              // Listen to for more messages
              window.addEventListener("message", (event) => {
                  if (event.origin !== this.context.origin)
                    return;

                  this.consumeMessage(event.data);
                }, false);
            }

            if (this.method) {

              // Map the service status to appMode level and individual taxonModesMap
              this.initializeServiceStatus(this.context)

              this.handleMethod(this.method, this.context)
            }

            this.initialized = true
            // Handle any messages that where posted before init finished. Note this is also checked by the sender now. So this is double checking.
            if (this.preInitMessages.length > 0) {
              // console.log(`Process ${this.preInitMessages.length} messages that were sent before init finished`)
              this.preInitMessages.forEach(nextMessage => {
                this.processMessage(nextMessage)
              })
            }

            // Handle if we are initing on the shopping cart page
            if (this.context.cartPath && this.context.originalPath && this.context.cartPath === this.context.originalPath) {
              this.recordVisitedCartEvent()
            }
          } else {
            this.postResponse(toRaw(this.context), {error: {message: 'Access denied'}}, true)
          }
        }
      },
      initializeServiceStatus: function (context) {
        // console.log(`Pikle Connect Mappoing service status ${JSON.stringify(context.serviceStatus)}`)
        if (context.serviceStatus) {
          this.appMode = context.serviceStatus.status
          this.taxonModesMap = context.serviceStatus.taxonModes
        }
      },
      consumeMessage: function(messageData) {
        if (!this.initialized) {
          // Make a list of messages if we are not ready to process them yet.
          // Note the sender also checks if the frame is loaded now, so not sure if this can happen at this end any more.
          // Maybe if the frame is loaded with a method to execute on init then this could happen.
          // E.g. frame is loaded, but initilization has not complete processing the first message when this message is received.
          // Though if we just set initilized = true before processing any message in init then that should not happen either.
          this.preInitMessages.push(messageData)
        } else {
          this.processMessage(messageData)
        }
      },
      processMessage: function(messageData) {
        const action = messageData.action;
        const method = messageData.method;
        const context = messageData.context;

        if (action === 'piklereq' && method && context && context.appKey === this.context.appKey) {
          // Map the service status to appMode level and individual taxonModesMap
          this.initializeServiceStatus(context)

          this.handleMethod(method, context)
        }
      },
      handleMethod: async function (method, context) {
        // this.context = {}
        let handled = false
        switch(method) {
          case 'getCompareStatus':
            // if(this.buildContext()) {
              try {
                // console.log(`Should run get compare status with context ${JSON.stringify(this.context)}`)
                const comparisonElements = {}
                // Could be dealing with a list
                if (context.elements) {
                  context.elements.forEach((elementContext) => {
                    if (elementContext.href) {
                      comparisonElements[elementContext.href] = {...elementContext, method: method}
                    }
                  });

                }
                // Or a single element
                else if (context.href && context.targetEl) {
                  comparisonElements[context.href] = {...context, method: method}
                }

                // Fetch the taxonModesMap
                // const taxonModesResponse = await this.loadTaxonServiceModes()
                // if (taxonModesResponse) {
                //   this.appMode = taxonModesResponse.status
                //   this.taxonModesMap = taxonModesResponse.taxonModes
                // }
                

                this.getBatchCompareStatus(comparisonElements, {...context, method: method}).then(batchCompareRes => {
                  if (batchCompareRes && batchCompareRes.status === 'success') {
                    // const elementCount = Object.keys(comparisonElements).length
                    if (!this.persistent/* && batchCompareRes.processedCount === elementCount*/) {
                      self.postExit({status: 'success'}, context.origin)
                    }
                  }
                })

              } catch(error) {
                let errorMessage = `Error calling checkcomparing - ${error.toString()}`
                this.postResponse(toRaw(context), {error: {message: errorMessage}}, true)
              }
            // }
            handled = true
            break;
          case 'toggleCompare':
            // if(this.buildContext()) {
              // console.log(`Should run toggle compare with context ${JSON.stringify(this.context)}`)
              this.toggleCompare({...context, method: method})
            // }
            handled = true
            break;
          default:
            handled = false
        }
        if (!handled) {
          const defaultMessage = `Pikle connect plugin - unexpected method ${this.method}`
          // console.log(defaultMessage)
          this.postResponse(toRaw(context), {error: {message: defaultMessage}}, true)
        }
      },
      buildContext: function () {
        let success = false
        this.context = {}
        const queryParams = this.$route.query['params'] || null
        // console.log(`Decode params ${JSON.parse(queryParams)}`)
        if (queryParams) {
          const embedderParams = JSON.parse(decodeURIComponent(queryParams))
          this.context = {method: this.method, ...embedderParams}
          // The context can be for a single element or a list of elements
          if (this.context.appKey && this.context.origin && this.context.elements) {
            success = true
          }
          else if (this.context.taxon && this.context.href && this.context.appKey && this.context.targetEl && this.context.origin) {
            success = true
          } else if (this.context.appKey && this.context.origin) {
            // Can just be to initialize the iframe
            success = true
          }
        }
        // console.log(`Finished building context with success ${success} context is ${JSON.stringify(this.context)}`)
        return success
      },
      getBatchCompareStatus: async function (elementContexts, initContext) {
        if (!this.pikleUID) {
          return false
        }

        try {
          // Group compare elements by taxon so we can look them up by appkey-taxon.
          const taxonGroups = {}
          const elementKeys = Object.keys(elementContexts)
          // console.log(`getBatchCompareStatus for ${elementKeys.length} items`)
          // Ensure each compare element has a known taxon. We might need to look them up if not specified by the user
          const unknownTaxons = []
          elementKeys.forEach((nextElementKey) => {
            const nextElement = elementContexts[nextElementKey]
            if (nextElement.taxon) {
              if (!taxonGroups[nextElement.taxon]) {
                taxonGroups[nextElement.taxon] = []
              }

              taxonGroups[nextElement.taxon].push(nextElement.href)
            } else {
              unknownTaxons.push(nextElement)
            }
          });

          // console.log(`Have unknownTaxons ${unknownTaxons.length}`)
          if (unknownTaxons.length > 0) {
            const taxonUrls = unknownTaxons.map(next => next.href)
            const taxonsPayload = {urls: taxonUrls, appKey: initContext.appKey}
            
            const getTaxonsURL = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/itemtaxons`
            // const appCheckToken = this.authUtility ? await this.authUtility.getAppCheckToken() : null

            const itemTaxonsResponse = await axios.post(getTaxonsURL, taxonsPayload, {
              headers: {
                'Content-Type': 'application/json'
                // 'X-Firebase-AppCheck': appCheckToken
              }
            })

            if (itemTaxonsResponse && itemTaxonsResponse.data && itemTaxonsResponse.data.itemTaxonMap) {
              Object.entries(itemTaxonsResponse.data.itemTaxonMap).forEach(([nextItemUrl, itemEntry]) => {
                const itemTaxon = itemEntry.taxon
                const itemPOID = itemEntry.poid
                if (!taxonGroups[itemTaxon]) {
                  taxonGroups[itemTaxon] = []
                }
                taxonGroups[itemTaxon].push(nextItemUrl)
                // Set the taxon and poid for the element
                if (elementContexts[nextItemUrl]) {
                  elementContexts[nextItemUrl].taxon = itemTaxon
                  elementContexts[nextItemUrl].poid = itemPOID
                }
              })
            }
          }

          const taxonKeys = Object.keys(taxonGroups)
          // console.log(`Processing ${taxonKeys.length} taxons`)
          for (var t = 0; t < taxonKeys.length; t++) {
            const taxonKey = taxonKeys[t]
            const urls =  taxonGroups[taxonKey]
            // let processedCount = 0

            // Check the taxon settings to see if this taxon is disabled. In which case make all the options missing.
            let taxonMode = this.appMode // Default to app level mode
            // Validate that the app level mode is not more restrictive than any taxon level override
            if (this.taxonModesMap && this.taxonModesMap[taxonKey]) {
              const appLevelPriority = this.modePriorityMap[this.appMode]
              const taxonLevelPriority = this.modePriorityMap[this.taxonModesMap[taxonKey]]
              if (appLevelPriority > taxonLevelPriority) {
                // Revert to the app level priority if it is higher than taxon level
                taxonMode = this.appMode
              } else {
                taxonMode = this.taxonModesMap[taxonKey]
              }
            } else {
              taxonMode = this.appMode
            }

            // const taxonMode = initContext.serviceStatus;
            if (taxonMode === 'testing') {
              // console.log('Import auth')
              await this.handleAuth()

              if (this.authenticated && this.currentUserUID) {
                // Check access based on authenticated user
                this.pikleUID = this.currentUserUID;
                // console.log(`set pikleUID to ${this.pikleUID}, checking testing access`)
                this.hasTestingAccess = await this.checkServiceAccess(/*this.serviceId*/)
                // console.log(`set hasTestingAccess to ${this.hasTestingAccess}`)
              }
            }

            // console.log('Batch check compare logic')
            if (!taxonMode || taxonMode === 'enabled' || (taxonMode === 'testing' && this.hasTestingAccess)) {

              if (initContext.ignoreUserState) {
                // Just update all the elements with a taxon to mark them as not comparing
                urls.forEach(nextURL => {
                  const buttonContext = elementContexts[nextURL]
                  this.postResponse(buttonContext, {isComparing: false}, false) // Don't exit.
                })
              }
              else {
                // Check the comparing status for this user of each element
                // Chunk the urls over 20 so we get a response for the UI sooner than later
                const urlChunks = []
                let i, j
                const chunk = 10
                for (i = 0, j = urls.length; i < j; i += chunk) {
                  urlChunks.push(urls.slice(i, i + chunk))
                }

                // console.log(`Have ${urlChunks.length} url chunks`)
                // Try reversing the chunks so that the last chunk suffers from the lag of cold starts instead of the first
                urlChunks.reverse()
                for (let index = 0; index < urlChunks.length; index++) {
                  // TODO move this to an async function and run without await
                  const nextUrlChunk = urlChunks[index];
                  this.checkComparing(nextUrlChunk, taxonKey, initContext, elementContexts);
                }

              }
            } else {
              urls.forEach(nextURL => {
                const buttonContext = elementContexts[nextURL]
                this.postResponse(buttonContext, {isMissing: true, isComparing: false}, false) // Don't exit.
              })
            }
          }

          // Iterate elementContexts and find any with no taxon even after looking up taxon.
          // For these we need to send a response. Indicate they are as missing to disable comparison for them.
          const contextValues = Object.values(elementContexts)
          const contextsWithNoTaxon = contextValues.filter(next => {return !next.taxon})
          // console.log(`Post response for ${contextsWithNoTaxon.length} items with no taxon`)
          contextsWithNoTaxon.forEach(nextContext => {
              this.postResponse(nextContext, {isMissing: true, isComparing: false}, false) // Don't exit.
          })
          // Object.values(elementContexts).forEach(nextContext => {
          //   if (!nextContext.taxon) {
          //     this.postResponse(nextContext, {isMissing: true, isComparing: false}, false) // Don't exit.
          //   }
          // })

          // return {status: 'success', proccessedCount: processedCount}
          return {status: 'success'}
        }

        catch (error) {
          console.log(error.response); // this is the main part. Use the response property from the error object
          this.postResponse(toRaw(initContext), {error: {message: 'Unexpected response from batch checkcomparing', status: error.response}}, true)
          return error.response;
        }

      },
      initJWT: async function () {
        // Invalidate expired tokens
        if (this.jwtToken && this.jwtTokenCreatedAt) {
          const currentTime = Date.now()
          if ((currentTime - this.jwtMaxAge) > this.jwtTokenCreatedAt ) {
            this.jwtToken = null
            this.jwtTokenCreatedAt = null
          }
        }

        if (!this.jwtToken) {
          // Need app check to get a token
          // await this.initAppCheck(true)
          // const appCheckToken = this.authUtility ? await this.authUtility.getAppCheckToken() : 'no-auth'
          const tokenResponse = await axios.post(`${Constants.JSSDK_API_BASE_PATH}/auth/token`, {appKey: this.context.appKey, uid: this.pikleUID}, {
            headers: {
              'Content-Type': 'application/json',
              // 'X-Firebase-AppCheck': appCheckToken
            }
          })

          if (tokenResponse && tokenResponse.status === 200 && tokenResponse.data && tokenResponse.data.token) {
            this.jwtToken = tokenResponse.data.token
            this.jwtTokenCreatedAt = Date.now()
          }
        }
      },
      waitForTimeout(millisec) { 
          return new Promise(resolve => { 
              setTimeout(() => { resolve('') }, millisec); 
          }) 
      },
      initAppCheck: async function (delayAfterInit) {
        // Lazy import auth
        if (!this.authUtility || !this.authUtility.appCheck) {
          // First import authUtil if not already done
          if (!this.authUtility) {
            const { default: AuthUtil } = await import('../pluginsAuthUtil')
            this.authUtility = AuthUtil
            this.authUtility.init(this.firebaseApp)
          }

          this.authUtility.initAppCheck(this.firebaseApp)
          if (delayAfterInit) {
            this.waitForTimeout(1000)
          }
        }
      },
      handleAuth: async function () {
        // Lazy import auth
        const { default: AuthUtil } = await import('../pluginsAuthUtil')
        // console.log('Dynamically imported authutil')
        // AuthUtil.init(this.$firebaseApp)
        // console.log('Dynamically imported authutil')

        if (!this.authUtility) {
          this.authUtility = AuthUtil
        }
        this.authUtility.init(this.firebaseApp)

        // import { onAuthStateChanged } from "firebase/auth";
        const { onAuthStateChanged } = await import('firebase/auth');

        // console.log('Dynamically imported onAuthStateChanged')

        return new Promise((resolve, reject) => {
          const unsubscribe = onAuthStateChanged(this.authUtility.auth, (user) => {
              unsubscribe();
              if (user) {
                this.currentUser = user
                this.authenticated = true
                this.currentUserUID = user ? user.uid : null;
                // console.log('Set currentUserUID ' + this.currentUserUID)
              }
              resolve(user);
          }, reject);
        });
      },
      toggleCompare: async function (context) {
        if (!this.pikleUID) {
          return
        }
        // console.log(`Toggle compare for ${this.pikleUID}`)
        try {
          const optionModel = {url: context.href, taxon: context.taxon, appKey: context.appKey, uid: this.pikleUID}
          // Name and ImgSrc, overrides
          if (context.name) {
            optionModel.name = context.name
          }
          if (context.imgSrc) {
            optionModel.imgSrc = context.imgSrc
          }

          // Feature value overrides
          if (context.featureValues) {
            optionModel.featureValues = context.featureValues
          }
          
          // dataCartURL, dataCartMethod and dataCartPayload are optional overrides that will update the backend as well.
          if (context.dataCartURL) {
             const cartData = {url: context.dataCartURL}
            
            if (context.dataCartMethod) {
              cartData.method = context.dataCartMethod
            }
            if (context.dataCartPayload) {
              cartData.payload = context.dataCartPayload
            }
            optionModel.appCartData = cartData
          }
          if (context.poid) {
            optionModel.optionId = context.poid
          }

          // Ensure app check is inited for toggle compare call
          // await this.initAppCheck()
          
          const toggleOptionURL = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/togglecompare`
          // const appCheckToken = this.authUtility ? await this.authUtility.getAppCheckToken() : null

          // Ensure we have a jwt token
          await this.initJWT()
          const response = await axios.post(toggleOptionURL, optionModel, {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': this.jwtToken
              // 'X-Firebase-AppCheck': appCheckToken
            }
          })

          if (response && response.status === 200 && response.data) {
            const toggleState = response.data.comparing
            const autoScrape = response.data.autoRefreshOn

            const shouldExit = !this.persistent && autoScrape !== true
            this.postResponse(toRaw(context), {isComparing: toggleState}, shouldExit) // Let checkurl finish if autoScrape is on, even if we are not persistent

            // Check if isComparing is TRUE and response.data.autoRefreshOn is on and then call a hash check endpoint for this option
            // console.log(`isComparing = ${toggleState} and autoScrape = ${autoScrape}`)
            if (toggleState === true && autoScrape === true) {

              // this.postResponse(context, {isComparing: toggleState}, false) // Don't exit. Let checkurl finish

              // Check this option is up to date
              // console.log(`Calling checkurl with body = ${JSON.stringify(optionModel)}`)

              // Ensure app check is inited for toggle compare call
              await this.initAppCheck()
              const appCheckToken = this.authUtility ? await this.authUtility.getAppCheckToken() : null

              const self = this
              axios.post(`${Constants.JSSDK_API_BASE_PATH}/comparesdk/checkurl`, optionModel, {
                headers: {
                  'Content-Type': 'application/json',
                  // 'Authorization': `Bearer ${token}`,
                  'X-Firebase-AppCheck': appCheckToken
                }
              }).then(function () {
                if (!self.persistent) {
                  self.postExit({status: 'success'}, context.origin)
                }
              }).catch((error) => {
                let errorMessage = 'checkurl Error'
                if (error.response && error.response.data) {
                  errorMessage += ` - ${error.response.data.error}`
                  // console.log(`Error updating compare status for ${self.context.href}. Err: ${error.response.data.error}`)
                }
                self.postExit({error: {message: errorMessage}}, context.origin)
              })
              // console.log(`checkurl finished: ${JSON.stringify(checkResponse)}`)
            }

          } else {
            this.postResponse(toRaw(context), {error: {message: 'Unexpected response from checkcomparing', status: response.status}}, true)
          }
        } catch(error) {
          let errorMessage = `Error calling togglecompare - ${error.toString()}`
          this.postResponse(toRaw(context), {error: {message: errorMessage}}, true)
        }
      },
      loadTaxonServiceModes: async function (/*serviceIdentifier*/) {
        let res = null
        // R.B a suggestion for handling other service types
        // Get service endpoint from identifier
        // let serviceEndpoint = null
        // switch(serviceIdentifier) {
        //   case 'comparison':
        //     serviceEndpoint = 'comparesdk'
        //     break;
        //   default:
        //     handled = null
        // }
        // // If we support the service than check it
        // if (serviceEndpoint) {
        const statusURL = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/mode`
        // const appCheckToken = this.authUtility ? await this.authUtility.getAppCheckToken() : null

        const response = await axios.post(statusURL, {appKey: this.context.appKey}, {
          headers: {
            'Content-Type': 'application/json'
            // 'X-Firebase-AppCheck': appCheckToken
          }
        })
        // Set result according to true if the response status is active
        if (response && response.status === 200 && response.data) {
          res = response.data || null
        }
        // }

        return res
      },
      checkServiceAccess: async function (/*serviceIdentifier*/) {
        if (!this.authenticated) {
          return false
        }

        let res = false
        // R.B a suggestion for handling other service types
        // Get service endpoint from identifier
        // let serviceEndpoint = null
        // switch(serviceIdentifier) {
        //   case 'comparison':
        //     serviceEndpoint = 'comparesdk'
        //     break;
        //   default:
        //     handled = null
        // }
        // // If we support the service than check it
        // if (serviceEndpoint) {
        const token = this.currentUser && (await this.currentUser.getIdToken())
        const appCheckToken = this.authUtility ? await this.authUtility.getAppCheckToken() : null
        const accessURL = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/access`

        const response = await axios.post(accessURL, {appKey: this.context.appKey}, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'X-Firebase-AppCheck': appCheckToken
          }
        })
        // Set result according to true if the response status is active
        if (response && response.status === 200 && response.data) {
          // res = response.data.status === 'active'
          res = response.data.hasAccess
        }
        // }

        return res
      },
      checkComparing: async function (nextUrlChunk, taxonKey, initContext, elementContexts) {
        // console.log(`nextUrlChunk length = ${nextUrlChunk.length}`)
        // console.log(`call batch check comparing for UID ${this.pikleUID}`)
        const payload = {urls: nextUrlChunk, taxon: taxonKey, appKey: initContext.appKey, uid: this.pikleUID}
        
        const checkComparingURL = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/batchcheckcomparing`
        // const appCheckToken = this.authUtility ? await this.authUtility.getAppCheckToken() : null

        const response = await axios.post(checkComparingURL, payload, {
          headers: {
            'Content-Type': 'application/json'
            // 'X-Firebase-AppCheck': appCheckToken
          }
        })

        if (response && response.data) {

          // Handle urls that returned comparing = true
          if (response.data.comparisonMap) {
            // Returns a map of urls with compare state
            Object.keys(response.data.comparisonMap).forEach(nextURL => {
              const comparisonState = response.data.comparisonMap[nextURL]
              const buttonContext = elementContexts[nextURL]
              // console.log(`Post response for ${nextURL} with compar state ${comparisonState}`)
              // console.log(`Post response for ${nextURL} context = ${JSON.stringify(buttonContext)}`)
              this.postResponse(buttonContext, {isComparing: comparisonState}, false) // Don't exit.
            });
          }

          // Handle any urls that are missing (this means there are no matching items in the apps taxon catalog)
          if (response.data.missingMap) {
            // Returns a map of urls with compare state
            Object.keys(response.data.missingMap).forEach(nextURL => {
              const buttonContext = elementContexts[nextURL]
              this.postResponse(buttonContext, {isMissing: true, isComparing: false}, false) // Don't exit.
            });
          }

          // Indicate if the pikleUID is comparing even though the comparisonMap is empty. The UID might be comparing something which is not visible on the screen.
          // e.g. not in the given list of urls. But the UI will still want to be informed in order to load other compontents like the CompareBoard.
          if (response.data.additionalComparisonsMap && Object.keys(response.data.additionalComparisonsMap).length > 0) {
            // We only need to trigger this once to indicated isComparing is true for something as the items to not represent visible elements on the screen and one event
            // is sufficient for other logic like loading the compar board
            const noElementContext = {
              appKey: initContext.appKey,
              origin: initContext.origin,
              method: initContext.method,
              taxon: taxonKey
            }
            // console.log(`Post response for is comparing with no element ${JSON.stringify(noElementContext)}`)
            this.postResponse(noElementContext, {isComparing: true}, false) // Don't exit.
          }
        }
      },
      recordVisitedCartEvent: async function () {
        if (!this.pikleUID || !this.context || !this.context.appKey) {
          return
        }

        const eventData = {eventId: 'visitedCartEvent', appKey: this.context.appKey, uid: this.pikleUID}
        const comparisonEventUrl = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/event`

        // Ensure we have a jwt token
        await this.initJWT()

        await axios.post(comparisonEventUrl, eventData, {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': this.jwtToken
          }
        })
      },
      postResponse: function (context, payload, exit) {
        const messageData = {action: 'response', context: context, ...payload}
        window.parent.postMessage(messageData, context.origin)
        if (exit) {
          this.postExit(payload, context.origin)
        }
      },
      postExit: function (payload, origin) {
        const messageData = {action: 'exit', embedder: this.embedderId, ...payload}
        window.parent.postMessage(messageData, origin)
      }
    }
  }
</script>
